module.exports = __webpack_public_path__ + "static/media/banner.25e8466b.png";